// Launch OS brand images (icon v2, Kyle Oct 28). The icon is the default picture for campaign elements
// in galleries (it replaced the stock Flowbite logo); in dark mode brand.css swaps in the dark version.
// The mark (flat badge) is the app's own logo, the same in both modes.
import "./brand.css";

export const LAUNCH_OS_ICON = "/assets/brand/launch-os-icon.svg";
export const LAUNCH_OS_MARK = "/assets/brand/launch-os-mark.svg";
